/** @format */

import styled from 'styled-components';

export const StyledNavigation = styled.nav`
  height: 45px;
  background: white;
  border-radius: 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: black;
  padding: 0.25rem;
  margin-bottom: 0.5rem;
  i {
    cursor: pointer;
  }
`;

export const SlideIndex = styled.span`
  font-variant-numeric: tabular-nums;
  font-family: Figtree, system-ui, -apple-system !important;
  font-size: 1rem;
  display: flex;
  gap: 6px;
  align-items: center;
  justify-content: center;
  user-select: none;
`;

export const StyledNavigationButton = styled.button`
  aspect-ratio: 1;
  height: 100%;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f7f9fa;
  border: none;
  border-radius: 0.25rem;
  transition: all 0.3s ease;
  &:hover {
    background: #dbe2e8;
  }
`;
